export default {
  title: {
    it: 'Family Mode',
    de: 'Family Mode',
    fr: 'Family Mode',
    en: 'Family Time!'
  },

  description: {
    it: 'Crea i tuoi avatar e dai il via al divertimento insieme ai tuoi bambini.',
    de: 'Willkommen im Family Mode! Gestalte eure Familien-Avatare und startet gemeinsam ins Abenteuer.',
    fr: 'Bienvenue dans Family Mode ! Crée les avatars de ta famille et lance-toi dans l’aventure ensemble.',
    en: "Welcome to Family Mode! Design your family crew and dive into the fun! Don't worry — you can switch things up later."
  },

  button: {
    it: 'Inizia subito',
    de: 'Jetzt starten',
    fr: 'Commencer',
    en: 'Okay!'
  }
};
